import { useNextEditionViewModel } from '@/components/home/next-edition/useNextEditionViewModel';
import MotionRoot from '@/components/v2/primitives/MotionRoot';
import { HUE_MARCA } from '@/design/hues';

import Duvidas from './Duvidas';
import Galeria from './Galeria';
import HeroCarrossel from './HeroCarrossel';
import LivrosQueJaLemos from './LivrosQueJaLemos';
import Marquee from './Marquee';
import ProximaEdicao from './ProximaEdicao';
import { useAcervo } from './useHomeData';

/**
 * Home v2.
 *
 * O FAQ desceu para cá e virou a seção de dúvidas; o Sobre continua
 * sendo página própria em /sobre.
 *
 * As bandas alternam creme e rosa. As duas últimas são creme seguidas,
 * separadas pelo fio que `.banda-creme + .banda-creme` desenha:
 *
 *   carrossel · fita(rosa) · edição(creme) · galeria(rosa)
 *   · acervo(creme) · dúvidas(creme)
 */
export const HomeV2 = () => {
  const { evento, loading: carregandoEvento } = useNextEditionViewModel();
  const { livros, carregando: carregandoAcervo } = useAcervo();

  return (
    <MotionRoot>
      <div
        data-hue={HUE_MARCA}
        className="min-h-screen bg-background text-on-surface selection:bg-primary-fixed selection:text-on-primary-fixed"
      >
        <HeroCarrossel />

        <Marquee livros={livros} />

        {/* ProximaEdicao sempre rende algo — com encontro marcado ou com
            o convite para a comunidade — então a home nunca abre numa
            seção vazia. */}
        <ProximaEdicao evento={evento} carregando={carregandoEvento} />

        <Galeria />

        <LivrosQueJaLemos livros={livros} carregando={carregandoAcervo} />

        <Duvidas />
      </div>
    </MotionRoot>
  );
};

export default HomeV2;
